import { cn } from "../../../Utils/helper";

export function FormSelect({
  icon,
  options,
  value,
  onChange,
  rightIcon,
  name,
  classNameText,
  iconName,
}) {
  return (
    <div className="flex gap-1.5 items-center px-3 h-[50px] w-full leading-none whitespace-nowrap bg-white rounded-lg border border-solid border-light-grey">
      {icon && (
        <img
          loading="lazy"
          src={icon}
          alt=""
          className="object-contain shrink-0 self-stretch my-auto w-5 aspect-square"
        />
      )}
      {iconName && (
        <div className="w-6 flex justify-center items-center">
          <span className={`icon icon-${iconName} text-xl text-mid-gray`} />
        </div>
      )}
      {/* <select
        value={value}
        onChange={onChange}
        className="flex-1 shrink self-stretch my-auto min-w-60 bg-transparent border-none outline-none"
      > */}
      <select
        name={name}
        value={value?.value || ""}
        onChange={(e) => {
          const selectedOption = options.find((option) => option.value === e.target.value);
          onChange(selectedOption);
        }}
        className={cn(
          "flex-1 shrink self-stretch my-auto min-w-60 bg-transparent border-none outline-none text-black text-base",
          classNameText
        )}
      >
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <span className="icon icon-chevron-left rotate-90 mr-1" />
    </div>
  );
}
